import { render, staticRenderFns } from "./Application_for_destruction.vue?vue&type=template&id=48d96499&scoped=true"
import script from "./Application_for_destruction.vue?vue&type=script&lang=js"
export * from "./Application_for_destruction.vue?vue&type=script&lang=js"
import style0 from "./Application_for_destruction.vue?vue&type=style&index=0&id=48d96499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d96499",
  null
  
)

export default component.exports